import http from "../../HttpConfig"
import { APIS_ENDPOINTS } from "../../SERVICE-CONSTANTS"
import { UpsertRequestZamenValidationPayload } from "./types"

const endpoints = APIS_ENDPOINTS.requestZamenValidation

export const request_upsert = async (
  payload: UpsertRequestZamenValidationPayload
) => {
  return http.post(endpoints.upsert, payload)
}

export const request_getToEdit = async ({
  requestId,
  requestZamenId,
  requestZamenLegalId,
  requestZamenPlaceId,
}: {
  requestId: number
  requestZamenId?: number | null
  requestZamenLegalId?: number | null
  requestZamenPlaceId?: number | null
}) => {
  const params = new URLSearchParams()
  params.append('RequestId', String(requestId))
  if (requestZamenId) params.append('RequestZamenId', String(requestZamenId))
  if (requestZamenLegalId) params.append('RequestZamenLegalId', String(requestZamenLegalId))
  if (requestZamenPlaceId) params.append('RequestZamenPlaceId', String(requestZamenPlaceId))

  return http.get(endpoints.getToEdit + '?' + params.toString())
}